module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/fraternity-2-48553179bd7b1cc9d09085ba521e58a3.jpg";